// extracted by mini-css-extract-plugin
export default {"kliksRowGroup":"style_kliksRowGroup__blMVt","kliksRow":"style_kliksRow__yTjmV"};